import { Component, Input } from '@angular/core';
import { IReservationReport } from '../../../../../utils/interfaces/reservation-report';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-reservation-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reservation-card.component.html',
  styleUrl: './reservation-card.component.scss'
})
export class ReservationCardComponent {
  @Input() reservation!: IReservationReport;

  getColumnTemplate(columns: string[]): { [key: string]: string } {
    return { 'grid-template-columns': `repeat(${columns.length}, 1fr)` };
  }
}
